export default function registerSduiMixins(app) {
  app.mixin({
    computed: {
      $me () {
        return this.$store.getters['users/me']
      }
    }
  })
}
